import React from "react";
interface Props {
  quantity: number;
}
const AddToCartSuccess = ({
  quantity
}: Props) => {
  // use key to re-animate this component every time the quantity is changed
  const key = quantity;
  return <div className="success-container" key={key} data-sentry-component="AddToCartSuccess" data-sentry-source-file="AddToCartSuccess.tsx">
      <div className="amount-in-cart">
        <div className="amount" data-testid="amount-in-cart">
          <span className="unit">{`${quantity} item${quantity > 1 ? "s" : ""}`}</span>
          {" added to your cart"}
        </div>
        <a href="/viewcart.cfm" className="btn btn-primary">
          <i className="icon-shopping-cart pr-1" />
          View Cart
        </a>
        <a href="/shipping-billinginfo.cfm" className="btn btn-orange">
          <i className="icon-lock pr-1" />
          Checkout
        </a>
      </div>
    </div>;
};
export default AddToCartSuccess;